import { createBrowserRouter } from 'react-router-dom';

import routes from './container/routeConfigs/routes.default';
import {
    createSentryBrowserRouter,
    initializeSentry,
} from './util/SentryUtil';

/**
 * Get the router
 * @returns The router for the application
 */
export async function getRouter() {

    const sentryInitialized = await initializeSentry();

    if (sentryInitialized) {
        const sentryWrappedBrowserRouter = await createSentryBrowserRouter();
        return sentryWrappedBrowserRouter(routes);
    }

    return createBrowserRouter(routes);
}
